import * as yup from 'yup'

export const ReplacementPartsFormSchema = yup.object().shape({
  productId: yup.number().required('Select your flange size.'),
  aobAcknowledged: yup
    .boolean()
    .oneOf([true], 'This acknowledgment is required'),
})
